import React from "react";
import "./Banner.css";

export default function Banner(){
    return(
        <div className="main_ban">
            <div className="ban1">
                <h1>BREATHE NEW LIFE INTO YOUR SCHEDULE, EVENTS AND ENHANCE YOUR PRODUCTIVITY</h1>
                <h2>"Simple is better than complex"</h2>
                <p> David McCullough</p><br/>
                <div className="btn">
                    <button className="login, login_ban"><a href="https://hisboti-kakaymi10.vercel.app" target="_blank">Log in/Sign Up</a></button>
                </div>
            </div>
            <div className="ban2">
                <img className="ban_img" src="https://img.freepik.com/premium-vector/cartoon-history-book-back-school-icon-vector-illustration_444196-1799.jpg?w=740" alt="banner"/>
            </div>
        </div>
    )
}
